/**
 * Dynamic Iframe Title Attribute Fixer
 * Adds title attributes to dynamically loaded iframes for accessibility
 */

(function() {
  'use strict';

  // Configuration: iframe IDs and their titles
  const iframeConfig = {
    'PBarNextFrame': 'Progress Bar Widget',
    'merchantwidgetiframe': 'Google Merchant Widget'
  };

  // Track which iframes we've already processed
  const processedIframes = new Set();

  /**
   * Add title to iframe if it matches our config
   */
  function addTitleToIframe(iframe) {
    const iframeId = iframe.id;

    // Skip if already processed
    if (processedIframes.has(iframeId)) {
      return;
    }

    // Check if this iframe is in our config
    if (iframeConfig.hasOwnProperty(iframeId)) {
      const title = iframeConfig[iframeId];

      // Add title attribute
      iframe.setAttribute('title', title);

      // Mark as processed
      processedIframes.add(iframeId);

      // Log for debugging (remove in production if desired)
      if (window.location.search.includes('debug')) {
        console.log('Added title to iframe:', {
          id: iframeId,
          title: title
        });
      }
    }
  }

  /**
   * Check all existing iframes on the page
   */
  function checkExistingIframes() {
    const iframes = document.querySelectorAll('iframe');
    iframes.forEach(addTitleToIframe);
  }

  /**
   * Initialize MutationObserver to watch for new iframes
   */
  function initMutationObserver() {
    // Check if MutationObserver is supported
    if (!('MutationObserver' in window)) {
      console.warn('MutationObserver not supported, iframe titles may not be added');
      return;
    }

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        // Check added nodes
        mutation.addedNodes.forEach((node) => {
          // Check if the node itself is an iframe
          if (node.nodeType === Node.ELEMENT_NODE && node.tagName === 'IFRAME') {
            addTitleToIframe(node);
          }

          // Check if the node contains iframes
          if (node.nodeType === Node.ELEMENT_NODE && node.querySelectorAll) {
            const iframes = node.querySelectorAll('iframe');
            iframes.forEach(addTitleToIframe);
          }
        });

        // Also check for attribute changes (in case id is added after iframe)
        if (mutation.type === 'attributes' &&
            mutation.target.tagName === 'IFRAME' &&
            mutation.attributeName === 'id') {
          addTitleToIframe(mutation.target);
        }
      });
    });

    // Start observing the document body for changes
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['id']
    });

    return observer;
  }

  /**
   * Initialize on DOM ready
   */
  function init() {
    // Check any iframes that might already exist
    checkExistingIframes();

    // Start watching for new iframes
    initMutationObserver();

    // Also do periodic checks as a fallback (every 2 seconds for first 10 seconds)
    let checksRemaining = 5;
    const fallbackInterval = setInterval(() => {
      checkExistingIframes();
      checksRemaining--;

      if (checksRemaining <= 0) {
        clearInterval(fallbackInterval);
      }
    }, 2000);
  }

  // Start when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
